<script>
import QuestionBaseDropdown from '@/components/questions/BaseDropdown';

export default {
  name: 'question-hear-about-us',
  extends: QuestionBaseDropdown,
  computed: {
    isRenderAfterFullfilled () {
      return this.needsHearAboutUs && this.needsPassword;
    },
    needsPassword () { return this.config.partnerSignin && this.stepData.userData !== undefined; },
    needsHearAboutUs () { return this.config.hiddenQuestions['hear-about-us'] === 0; },
  },
};
</script>
